import React from 'react';
import { Chip } from '@heroui/react';
import { Icon } from '@iconify/react';
import { StatisticsData } from '../types';
import { useTranslations } from '../../../../contexts/translation.context';

interface StatisticSubscribersCellProps {
  statistic: StatisticsData;
}

const StatisticSubscribersCell: React.FC<StatisticSubscribersCellProps> = ({ statistic }) => {
  const { t } = useTranslations();

  return (
    <div className="flex items-center gap-2">
      <div className="flex items-center gap-2">
        <span className="text-default-600">{t('statistics.table.subscribersLabel')}</span>
        <span className="font-semibold">{statistic.subscribersCount}</span>
      </div>
      <Chip
        size="sm"
        color={
          statistic.subscribersChangeType === 'positive'
            ? 'success'
            : statistic.subscribersChangeType === 'negative'
              ? 'danger'
              : 'default'
        }
        variant="flat"
        startContent={
          statistic.subscribersChangeType === 'positive' ? (
            <Icon height={12} icon={'solar:arrow-right-up-linear'} width={12} />
          ) : statistic.subscribersChangeType === 'negative' ? (
            <Icon height={12} icon={'solar:arrow-right-down-linear'} width={12} />
          ) : (
            <Icon height={12} icon={'solar:arrow-right-linear'} width={12} />
          )
        }
      >
        {statistic.subscribersChange}
      </Chip>
    </div>
  );
};

export default StatisticSubscribersCell;
